import React, { Component } from 'react';
import NavPilsItem from '../../../../components/Common/NavPilsItem/NavPilsItem';
import {connect} from "react-redux";
import {getUserPermission} from "src/selectors";

class NavTabs extends Component {

	render() {
		const { activeTab, changeTabHandler, handleExpandPanel, canViewBilling,
			canViewOrdersAndQuotes, canViewServicesAndEquipment, canViewTroubleTickets } = this.props;

		return (
			<ul className="nav nav-pills nav-scrollable" id="clientProfileTab" role="tablist">
				<NavPilsItem
					pillName="account360"
					pillHeader="360"
					activeTab={activeTab}
					changeTabHandler={changeTabHandler}
				/>

				{canViewServicesAndEquipment &&
					<NavPilsItem
						pillName="serviceAndEquipment"
						pillHeader="Services &amp; Equipment"
						activeTab={activeTab}
						changeTabHandler={changeTabHandler}
					/>
				}

				{canViewBilling &&
					<NavPilsItem
						pillName="billing"
						pillHeader="Billing"
						activeTab={activeTab}
						changeTabHandler={changeTabHandler}
					/>
				}

				{canViewOrdersAndQuotes &&
					<NavPilsItem
						pillName="ordersAndQuotes"
						pillHeader="Orders &amp; Quotes"
						activeTab={activeTab}
						changeTabHandler={changeTabHandler}
					/>
				}

				{canViewTroubleTickets &&
					<NavPilsItem
						pillName="troubleTickets"
						pillHeader="Trouble Tickets"
						activeTab={activeTab}
						changeTabHandler={changeTabHandler}
					/>
				}

				<li className="ml-auto">
					<button onClick={() => handleExpandPanel('leftPanel')} className="nav-link btn btn-link btn-panel-right-toggler d-none d-xl-block" type="button">
						<i className="fas fa-arrows-alt-h" />
					</button>
				</li>
			</ul>
		);
	}
}

const mapStateToProps = (state) => {
	const canViewOrdersAndQuotes = getUserPermission(state, 'CAM', 'CAM_VIEW_ORDER_TAB');
	const canViewServicesAndEquipment = getUserPermission(state, 'CAM', 'CAM_VIEW_SERVICE_LINE_TAB');
	const canViewBilling = getUserPermission(state, 'CAM', 'CAM_VIEW_BILLING_TAB');
	const canViewTroubleTickets = getUserPermission(state, 'CAM', 'CAM_VIEW_TROUBLE_TICKET_TAB');

	return {
		canViewOrdersAndQuotes,
		canViewBilling,
		canViewServicesAndEquipment,
		canViewTroubleTickets
	}
}

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(NavTabs);

